import { DocsBlockBuilder } from "../../../../../../tools/docs-block-builder/SDKDocsBlockBuilder";
import { DocsBlockCategory } from "../../../../../enums/SDKDocsBlockCategory";
const b = new DocsBlockBuilder();
/**
 * 1. Block metadata
 */
const id = "io.supernova.block.storybook";
const name = "Storybook";
const icon = "https://cdn-assets.supernova.io/blocks/icons/storybook.svg";
const descriptionShort = "Embed Storybook canvas";
const searchKeywords = [
    "storybook",
    "story",
    "stories",
    "example",
    "preview",
    "code",
    "react",
];
const helpText = "Embed a Storybook story to your documentation.";
const docsUrl = "https://learn.supernova.io/latest/documentation/types-of-blocks/code/storybook-1EGPhwBl";
/**
 * 2. Block properties
 */
const properties = {
    storybookUrl: b.storybookProperty({
        id: "embed",
        name: "Storybook URL",
        options: {
            allowCaption: true,
            allowResize: true,
            defaultHeight: 400,
            renderLayoutAs: "Iframe",
        },
        variants: {
            playground: {
                renderLayoutAs: "Playground",
                defaultHeight: 400,
                allowResize: true,
            },
        },
    }),
};
/**
 * 3. Block variants
 */
const variants = [
    b.variantUsingDefaultLayout({
        id: "playground",
        name: "Playground",
        description: "Embed a Storybook story with a preview of the component and controls to adjust the props.",
        image: "https://cdn-assets.supernova.io/blocks/variants/storybook-playground.svg",
        properties: [properties.storybookUrl],
    }),
    b.defaultVariantUsingDefaultLayout({
        name: "HTML iframe",
        description: "Embed a Storybook story in an iframe.",
        image: "https://cdn-assets.supernova.io/blocks/variants/storybook-iframe.svg",
        properties: [properties.storybookUrl],
    }),
];
/**
 * 4. Block item
 */
const blockItem = b.multiVariantItem({
    properties: [properties.storybookUrl],
    variants,
});
/**
 * 5. Block definition
 */
const block = b.singleItemBlock({
    id,
    name,
    icon,
    category: DocsBlockCategory.media,
    description: descriptionShort,
    item: blockItem,
    searchKeywords,
    onboarding: b.onboarding({
        helpText,
        documentationLink: docsUrl,
    }),
});
/** 6. Block export */
export { block as Storybook };
